import { styled } from '@mui/system';
import { Typography, Box } from '@mui/material';

export const TypographyStyledHeader = styled(Typography)({
  color: '#002A3A',
  fontSize: '1.125rem',
  fontWeight: 'bold',
  lineHeight: '1.5rem'
});

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '1.875rem'
});
